import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from '../../components/theme/theme';

export const BankAccountCardWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: 'auto',
    borderRadius: theme.spacing(3),
    border: `1px solid ${colors.greyPreset[10]}`,
    padding: theme.spacing(2),
    backgroundColor: colors.fullWhite,
    overflow: 'hidden',
    // cursor: 'pointer',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundPosition: 'right',
        borderRadius: theme.spacing(3),
        zIndex: 0,
        backgroundRepeat: 'no-repeat',
    },

    '& > *': {
        position: 'relative',
        zIndex: 1,
    },
    '& .bank-icon-wrapper': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        gap: 8,
        '& .bank-icon-name-wrapper': {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1.25),
        },
    },
    '& .account-info-container': {
        gap: 16,
    },
    '& .info-label': {
        display: 'block',
        marginBottom: 4,
    },
    '& .account-number-container': {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    '& .visibility-toggle-button': {
        padding: 0,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    '& .bankContent': {
        display: 'grid',
    },
}));

export const BankAccountsContainer = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));
